import { type UseQueryResult } from '@tanstack/react-query';

import { airLuggageJourneysApi } from 'api';
import { ApiQueryOptions } from 'hooks/api/queryHelper';
import { useProtectedQuery } from 'hooks/api/useProtectedQuery';
import {
  type AirLuggageJourney,
  type IAirLuggageJourney,
  transformToAirLuggageJourneyClass,
} from 'models/journeys/AirLuggageJourney';

const fetchAirLuggageForJourney = async (journeyId: number) => {
  const [error, response] =
    await airLuggageJourneysApi.fetchAirLuggageForJourneys(journeyId);

  if (error) {
    throw error;
  } else {
    return response;
  }
};

const useFetchAirLuggageJourneys = (
  journeyId: number,
  options: ApiQueryOptions = {},
) => {
  return useProtectedQuery({
    queryKey: ['journey', journeyId, 'airLuggages'],
    queryFn: () => fetchAirLuggageForJourney(journeyId),
    select: (data) =>
      (data as IAirLuggageJourney[]).map((airLuggageJourney) =>
        transformToAirLuggageJourneyClass(airLuggageJourney),
      ),
    ...options,
  }) as UseQueryResult<AirLuggageJourney[]>;
};

export default useFetchAirLuggageJourneys;
